import { jwtEnvAxios } from ".";

export function getAiNotebooksApi() {
  return jwtEnvAxios("ai-lab").get(`/notebook/detail`);
}

export function updateAiNotebookApi(id: string, data: any) {
  return jwtEnvAxios("ai-lab").put(`/notebook/${id}`, data);
}

export function createAiNotebookApi(data: any) {
  return jwtEnvAxios("ai-lab").post(`/notebook`, data);
}

export function deleteAiNotebookApi(id: string) {
  return jwtEnvAxios("ai-lab").delete(`/notebook/${id}?force`);
}

export function getAiNotebookEditorsApi() {
  return jwtEnvAxios("ai-lab").get(
    `/notebook/capabilities/editor?compatibleWithFramework`
  );
}

export function getAiNotebookFreamworkApi() {
  return jwtEnvAxios("ai-lab").get(
    `/notebook/capabilities/framework?compatibleWithEditor`
  );
}

export function getAiRegionsDataApi() {
  return jwtEnvAxios("ai-lab").get(`/capabilities/region`);
}

export function getAiResourceFlavorsApi(region: string) {
  return jwtEnvAxios("ai-lab").get(`/capabilities/region/${region}/flavor`);
}
